import { render, staticRenderFns } from "./horizontal-naj-box.vue?vue&type=template&id=c0f559c8&scoped=true&"
import script from "./horizontal-naj-box.vue?vue&type=script&lang=js&"
export * from "./horizontal-naj-box.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-naj-box.vue?vue&type=style&index=0&id=c0f559c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f559c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
